import React from "react";
import {
  ContainerReports,
  ContainerIframe,
} from "./MoodMeterReportContainer.styled";

const MoodMeterReportContainer = () => {
  const iframe =
    '<iframe title="TnS Mood Meter" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=caf6b90c-69f7-46f6-a461-22dda8a504a1&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" frameborder="0" allowFullScreen="true"></iframe>';
  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default MoodMeterReportContainer;
